export { default as SpotIllustration } from './spot-illustration';
